import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=56a5c9dd&scoped=true"
import script from "./Funds.vue?vue&type=script&lang=js"
export * from "./Funds.vue?vue&type=script&lang=js"
import style0 from "./Funds.vue?vue&type=style&index=0&id=56a5c9dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5c9dd",
  null
  
)

export default component.exports